import { Button, Result, Space, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

function NotFoundPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Result
      status="404"
      title={
        <Space direction="vertical" size={4} style={{ width: "100%" }}>
          <Typography.Title level={2} style={{ margin: 0 }}>
            404
          </Typography.Title>
          <Typography.Text type="secondary">
            {t("error.404.title")}
          </Typography.Text>
        </Space>
      }
      subTitle={t("error.404.subtitle")}
      extra={
        <Space>
          <Button onClick={() => navigate(-1)}>{t("button.go_back")}</Button>
          <Button type="primary" onClick={() => navigate("/")}>
            {t("button.go_home")}
          </Button>
        </Space>
      }
    />
  );
}

export default NotFoundPage;

